import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { PAGE_SIZE } from '../../../config/consts'
import { formatDateToStr } from '../../../utils/display'

interface GetPushNotificationStoreRankRequest {
  serviceId: string
  fromDate: Date | null // '2021-01-01'
  toDate: Date | null // '2021-01-02'
  limit?: number | null
  offset?: number | null
  sortTarget?: number | null
  isAsc?: boolean | null
}

interface GetPushNotificationStoreRankResponse {
  statusCode: number
  statusMessage: string
  pushNotificationStoreRankDatas: {
    siteId: number
    siteName: string
    pushNotificationCount: number
    pushNotificationOpenCount: number
    pushNotificationOpenCTR: number
  }[]
  totalCount: number
}

const useGetPushNotificationStoreRank = ({
  serviceId,
  fromDate,
  toDate,
  limit,
  offset,
  sortTarget,
  isAsc,
}: GetPushNotificationStoreRankRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetPushNotificationStoreRankResponse> => axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getPushNotificationStoreRank`)
  // common params
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  url.searchParams.append('fromDate', formatDateToStr(fromDate))
  url.searchParams.append('toDate', formatDateToStr(toDate))

  // sort params
  url.searchParams.append('limit', limit ? limit.toString() : PAGE_SIZE.toString())
  url.searchParams.append('offset', offset ? offset.toString() : '0')
  url.searchParams.append('sortTarget', sortTarget ? (sortTarget + 1).toString() : '0') // not 0-indexed
  url.searchParams.append('isAsc', isAsc ? 'true' : 'false')

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )

  return {
    pushNotificationStoreRank: data,
    pushNotificationStoreRankLoading: isLoading,
    pushNotificationStoreRankMutate: mutate,
  }
}

export default useGetPushNotificationStoreRank
